export const RQ_GET_BRAND_API = {
  url: 'api/brand/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_BRAND_REGISTER = {
  url: 'api/register/brand',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_BRAND = {
  url: 'api/update/brand/<%= id %>',
  method: 'PUT',
  auth: true,
};

export const RQ_DELETE_BRAND = {
  url: 'api/brand/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
